import { useLazyQuery, useMutation } from "@apollo/client";
import { createOrganization } from "../../organizations/api/mutations";
import {
    type CreateOrganizationMutation,
    type CreateOrganizationMutationVariables,
} from "../../organizations/api/mutations/createOrganization.gql-generated";
import { getOrganizations } from "../../organizations/api/query";
import { type GetCameraKitOrganizationsQuery } from "../../organizations/api/query/getOrganizations.gql-generated";
import { useOrganizationsRefetch } from "../../../shared/hooks";
import { enableOrganizaiton } from "../api/mutations/EnableOrganization";
import {
    type EnableOrganizationMutation,
    type EnableOrganizationMutationVariables,
} from "../api/mutations/EnableOrganization.gql-generated";

export function useOnboardingOrganization() {
    const setRefetchCounter = useOrganizationsRefetch();

    const [fetchAllOrgs, { data, loading: fetchLoading, error: fetchError }] =
        useLazyQuery<GetCameraKitOrganizationsQuery>(getOrganizations, {
            errorPolicy: "all",
            variables: {
                includeAllOrgs: true,
            },
        });

    const [createOrg, { loading: isCreating, error: createError }] = useMutation<
        CreateOrganizationMutation,
        CreateOrganizationMutationVariables
    >(createOrganization, {
        refetchQueries: [{ query: getOrganizations }, "getOrganizations"],
    });

    const [enableOrg, { loading: isEnabling, error: enableError }] = useMutation<
        EnableOrganizationMutation,
        EnableOrganizationMutationVariables
    >(enableOrganizaiton, {
        onCompleted: () => {
            setRefetchCounter((c) => c + 1);
        },
        onQueryUpdated: async (observableQuery) => {
            await observableQuery.refetch();
        },
    });

    return {
        loading: fetchLoading,
        error: fetchError,
        organizations: data?.getOrganizations?.organizations || [],
        createOrg,
        isCreating,
        createError,
        enableOrg,
        isEnabling,
        enableError,
        fetchAllOrgs,
    };
}
